import { ConfigState } from '../../../@types';

const initialState: ConfigState = {
  googleApiAccessToken: '',
  apiBaseURL: '',
  apiVersion: '',
  appVersion: '',
  bundleId: '',
  appleAppId: '',
  xBrandId: '',
  turnstileSiteKey: '',
};

export default initialState;
